"use client";

// packages/eden-list/src/components/Ordered.jsx
import styled from "styled-components";
import shared from './shared.js';
import { jsx } from "react/jsx-runtime";
var orderedStyles = {
  decimal: "decimal",
  upperLatin: "upper-latin",
  upperRoman: "upper-roman",
  lowerLatin: "lower-latin"
};
var Ol = styled.ol`
  ${shared};
  list-style-type: ${({ $listStyle }) => orderedStyles[$listStyle]};
`;
var Ordered = ({ children, listStyle = "decimal", ...props }) => /* @__PURE__ */ jsx(Ol, { $listStyle: listStyle, ...props, children });
Ordered.displayName = "Ordered";
var Ordered_default = Ordered;
export {
  Ordered_default as default
};
